import React, { useState, useEffect, Fragment } from 'react';
import { Transition } from '@headlessui/react';
import { useTimeoutFn } from 'react-use';
import useApi from '../api';
import Agent from './Agent';
import { useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { MessageType } from '../types';
import { conLog } from './utils/conLog';

interface EmbedAgentProps {
  isDraft?: boolean;
}


const EmbedAgent: React.FC<EmbedAgentProps> = ({ isDraft }) => {
  let [isOpen, setIsOpen] = useState(false)
  const [config, setConfig] = useState<any>({})
  const [sidebar, setSidebar] = useState<boolean>(true);
  const { get, getStream, post, postStream, put, patch, remove } = useApi();
  const { agentId } = useParams();
  const [links, setLinks] = useState<any>(undefined);
  const [starters, setStarters] = useState<any>(undefined);
  const [conversationId, setConversationId] = useState<any>(undefined);
  const [leadId, setLeadId] = useState<any>(undefined);
  const [messages, setMessages] = useState<MessageType[]>([]);
  const [welcomeMessage, setWelcomeMessage] = useState<string>('Welcome! How can I help you today?');
  const [visitorId, setVisitorId] = useState<string | undefined>(undefined);
  const [draftAgentId, setDraftAgentId] = useState<string | undefined>(undefined);

  function closeModal() {
    window.parent.postMessage('widgetCollapsed', '*'); // Notify parent window
    setTimeout(() => {
      setIsOpen(false);
    }, 50);
  }

  function openModal() {
    setIsOpen(true);
    if (localStorage.getItem('aimdocAutoOpen') === 'false') {
      localStorage.setItem('aimdocAutoOpen', 'true');
    }
    window.parent.postMessage('widgetOpened', '*'); // Notify parent window
  }

  const checkIfMobile = () => {
    return window.innerWidth < 1025;
  };

  function WidgetCollapsed() {
    let [isShowing, setIsShowing] = useState(false)
    let [, , resetIsShowing] = useTimeoutFn(() => setIsShowing(true), 500)

    return (
      <div className="aimdoc-widget-container flex flex-col items-end">
        <div className="aimdoc-widget-button h-14 w-14">
          <Transition
            as={Fragment}
            show={isShowing}
            enter="transform transition duration-[400ms]"
            enterFrom="opacity-0 rotate-[-120deg] scale-50"
            enterTo="opacity-100 rotate-0 scale-100"
            leave="transform duration-200 transition ease-in-out"
            leaveFrom="opacity-100 rotate-0 scale-100 "
            leaveTo="opacity-0 scale-95 "
          >
             <div
              onClick={(e) => {
                e.stopPropagation();
                openModal();
              }}
              className="aimdoc-widget-icon h-full w-full rounded-2xl shadow-xl transition hover:scale-105 hover:cursor-pointer flex items-center justify-center"
              style={{ backgroundColor: config.color }}
            >
              {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="stroke-white w-7 h-7">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
            </svg> */}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="" className="fill-white w-7 h-7">
              <path fillRule="evenodd" d="M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97-1.94.284-3.916.455-5.922.505a.39.39 0 0 0-.266.112L8.78 21.53A.75.75 0 0 1 7.5 21v-3.955a48.842 48.842 0 0 1-2.652-.316c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97Z" clipRule="evenodd" />
            </svg>

            </div>
          </Transition>
        </div>
      </div>
    )
  }

  function WidgetMessage() {
    let [isShowing, setIsShowing] = useState(false);
    let [, , resetIsShowing] = useTimeoutFn(() => setIsShowing(true), 500);

    const closePopup = () => {
      localStorage.setItem('aimdocPopupClosed', 'true');
      setIsShowing(false);
    };
  
    return (
      <div className="mr-2 ml-8">
        <div className="">
          <Transition
            as={Fragment}
            show={isShowing}
            enter="transform transition duration-[400ms]"
            enterFrom="opacity-0 rotate-[-10deg] scale-50"
            enterTo="opacity-100 rotate-0 scale-100"
            leave="transform duration-200 transition ease-in-out"
            leaveFrom="opacity-100 rotate-0 scale-100 "
            leaveTo="opacity-0 scale-95 "
          >
            <div className="flex rounded-xl border border-slate-100 shadow-sm p-2 w-full bg-white relative">
              {/* Container for positioning */}
              <div className="text-wrap text-xs font-light break-words">
                {config.popup_message}
              </div>
              {/* SVG positioned absolutely */}
              <div onClick={() => closePopup()} className="flex h-4 w-4 bg-black absolute -top-2 -right-2 rounded-full items-center text-xs hover:cursor-pointer">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="h-3 w-4 stroke-white">
                <path fillRule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
              </svg>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    );
  }

  const checkOrSetUserId = async () => {
    let userId = localStorage.getItem('aimdocUserId');
    if (!userId) {
      userId = uuidv4();  // Generate a unique identifier using uuid
      localStorage.setItem('aimdocUserId', userId);
    } else {
      try {
        const { data } = await post(`/latest-session/`, {
          visitor_id: userId,
          agent_id: agentId,
        });
        setConversationId(data.id);
        setMessages(data.messages);
        console.log(data.messages);
        setLeadId(data.lead.id);
      } catch (error) {
      }
    }
    setVisitorId(userId);
    return userId;
  };

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const status = isDraft ? 'draft' : 'live';
        const { data } = await get(`/agents/${agentId}/config?status=${status}`);
        setConfig(data);
        setLinks(data.links);
        setStarters(data.starters);
        setWelcomeMessage(data.welcome_message);
        if (data.draft_agent_id) {
          setDraftAgentId(data.draft_agent_id);
        }
        if (data.auto_open_enabled) {
          if (data.open_once_per_session && localStorage.getItem('aimdocAutoOpen') === 'true') {
            return;
          }
          setTimeout(() => {
            openModal();
            // set local storage to prevent auto open on refresh
            localStorage.setItem('aimdocAutoOpen', 'true');
          }, data.auto_open_seconds * 1000);
        }
        conLog(data);
      } catch (error) {
        console.error('Error getting agent config:', error);
      }
      const userId = await checkOrSetUserId();
      conLog('User ID:', userId);
    };

    fetchConfig();
  }, []);

  useEffect(() => {
      const fetchUserId = async () => {
        const userId = await checkOrSetUserId();
        conLog('User ID:', userId);
      };

      fetchUserId();
    }, [isOpen]);

    const queryParams = new URLSearchParams(window.location.search);
    const allParams: any = {};

    queryParams.forEach((value, key) => {
        allParams[key] = value;
    });

    conLog('All Params:', allParams);


    return (
      agentId ? (
        <div className={`${config.font} fixed z-[100000000] bottom-5 right-5 embed w-full`} style={{ backgroundColor: 'transparent' }}>
          {config && !isOpen && (
            <div className="flex flex-row justify-end" style={{ backgroundColor: 'transparent' }}>
              {config.popup_message_enabled && config.popup_message !== '' && !localStorage.getItem('aimdocPopupClosed') && (
                <WidgetMessage />
              )}
              <WidgetCollapsed />
            </div>
          )}
          {config && (
            <Transition appear show={isOpen} as={Fragment}>
              <div className="container relative z-[100000000] h-full" style={{ backgroundColor: 'transparent' }}>
                <Transition.Child
                  as={Fragment}
                >
                  <div className="fixed bg-opacity-50" style={{ backgroundColor: 'transparent' }} />
                </Transition.Child>
    
                <div className={`fixed inset-0 w-full transition-all duration-200`} style={{ backgroundColor: 'transparent' }}>
                  <div className="flex h-full justify-end" style={{ backgroundColor: 'transparent' }}>
                    <div className={`flex items-center justify-center w-full h-full text-center transition-all duration-200`} style={{ backgroundColor: 'transparent' }}>
                      <Transition.Child
                        as={Fragment}
                        enter="duration-[200ms] ease-in"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-[100ms]"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                      >
                        <div className={`w-full h-full transform overflow-hidden text-left align-middle shadow-xl transition-all`} style={{ backgroundColor: 'transparent' }}>
                          {visitorId && (
                            <Agent agentId={agentId} closeModal={closeModal} sidebar={sidebar} setSidebar={setSidebar} embedConfig={config} agentLinks={links} agentStarters={starters} lastConvId={conversationId} lastMessages={messages} existLeadId={leadId} visitorId={visitorId} welcomeMessage={welcomeMessage} allParams={allParams} draftAgentId={draftAgentId} />
                          )}
                        </div>
                      </Transition.Child>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          )}
        </div>
      ) : (
        <div></div>
      )
    );
  };
  
  export default EmbedAgent;